export enum EBitfStoreActions {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  RESET = 'RESET',
  SET_USER = 'SET_USER',
  UPDATE_USER = 'UPDATE_USER',
  BREACKPOINT = 'BREACKPOINT',
  SET_AUTH_TOKEN = 'SET_AUTH_TOKEN',
}
